/**
 * SelectList (dropdown) builder — verbatim from v1 (research/03 §5, §15.8;
 * REQ-ELEM-2). Preserves the inline `border:1px solid yellow` and the
 * `</select ></div >` closers.
 */
import { appState } from "../state/app-state";
import { escapeHtml, getConditionalDisplay, getToolTipHtml, parsedName , getElementWidthClass, optionValueAttr, t , dirAttr } from "./base";

export function buildDropDown(element: any): string {
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "div");

  var ddl =
    "<div class='element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    "</label><select style='border:1px solid yellow' data-identifier='" +
    element.Identifier +
    "' onchange='ChangeEvent(null, this)' class='calc-prop' data-calcname='" +
    parsedName(element.Name) +
    "' name=\"properties[" +
    parsedName(element.Name) +
    ']">';

  element.Options.forEach((option: any) => {
    let escapedLabel = escapeHtml(option.label);
    let escapedValue = escapeHtml(option.value);
    // Translations v1: visible text swapped; data-label (the pricing key) stays canonical.
    let visibleLabel = escapeHtml(t(option.label));
    ddl +=
      "<option data-val='" +
      escapedValue +
      "' data-label='" +
      escapedLabel +
      "'" +
      optionValueAttr(escapedLabel, visibleLabel) +
      dirAttr(option.label) +
      ">" +
      visibleLabel +
      "</option>";
  });
  ddl += "</select ></div >";

  return ddl;
}
